var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyboard-row"},_vm._l((_vm.row),function(key,idx){return _c('KeyButton',{key:idx,attrs:{"key_label":key,"control_states":_vm.control_states},on:{"click":e => _vm.$emit('click', e),"layout":e => _vm.$emit('layout', e)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }